import { Component, OnInit } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { dateStringFromISO8601 } from '../../../../../../utils';

import { AccountService } from '../../../../../../services/account/account.service';
import { MembershipPendingStaffApprovalInboxItem } from '../../../../../../models/inbox';
import { InboxService } from '../../../../../../services/inbox/inbox.service';
import {
  ReviewMembershipPendingStaffApprovalModalComponent
} from './modals/review-unlinked-membership-customer-modal/review-membership-pending-staff-approval-modal.component';

@Component({
  selector: 'app-inbox-memberships-pending-staff-approval',
  templateUrl: './inbox-memberships-pending-staff-approval.component.html',
  styleUrls: ['./inbox-memberships-pending-staff-approval.component.css']
})
export class InboxMembershipsPendingStaffApprovalComponent implements OnInit {

  public inboxItems: MembershipPendingStaffApprovalInboxItem[];

  public loadingInboxItems = false;

  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public dateStringFromISO8601 = dateStringFromISO8601;

  constructor(
    public accountService: AccountService,
    private inboxService: InboxService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    this.loadInboxItems();
  }

  public inboxItemsPresent() {
    return this.inboxItems && (this.inboxItems.length > 0);
  }

  public openReviewInboxItemModal(inboxItem: MembershipPendingStaffApprovalInboxItem) {
    const modalRef = this.modalService.open(ReviewMembershipPendingStaffApprovalModalComponent);
    modalRef.componentInstance.customerMembershipId = inboxItem.id;
    modalRef.componentInstance.showHideOption = true;
    modalRef.componentInstance.savedCallback = () => {
      this.loadInboxItems();
    };
  }

  private loadInboxItems() {
    this.loadingInboxItems = true;

    this.inboxService
      .getMembershipsPendingStaffApproval()
      .then(inboxItems => {
        this.inboxItems = inboxItems;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingInboxItems = false; });
  }

}
